import { render } from "./AssignPositionModal.vue?vue&type=template&id=55e2af0f&scoped=true"
import script from "./AssignPositionModal.vue?vue&type=script&lang=js"
export * from "./AssignPositionModal.vue?vue&type=script&lang=js"

import "./AssignPositionModal.vue?vue&type=style&index=0&id=55e2af0f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e2af0f"]])

export default __exports__